import React, {useContext, useEffect, useRef, useState} from 'react'
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import useTranslate from "../../../../modules/local/useTranslate";
import {godwords_getSuggestedWords_Api, godwordsSchema} from "../../../../apis/godwords";
import _ from "lodash"
import CRUD from "../../../Shared/enums/CRUD";
import {renderIf, renderIfElse} from "../../../Shared";
import {PiPlusBold} from "react-icons/pi";
import {IoHeartOutline, IoHeartSharp, IoPlaySkipBackOutline} from "react-icons/io5";
import {RiRefreshFill} from "react-icons/ri";
import {getAbsoluteLinkToDetail} from "../../../../helpers/getLinkToDetail";
import {BsCamera, BsCameraFill} from "react-icons/bs";
import {HeaderButton} from "../../../Organization/components/PageHeader";
import {GodWordCardItem} from "../components/GodWordCardItem";
import {useGodWords} from "../functions/useGodWords";
import RequiredAdmin from "../../../../components/RequiredAdmin";
import {Share} from "../../../../components/Feed/Share";
import WoGContext from "../WoGContext";
import getTitle from "../../../../helpers/getTitle";
import {SelectEntityItem} from "../../../../components/SelectEntityItem";
import {useHistory} from "../../../../modules/navigation/useRouter";
import getLinkToDetail from 'helpers/getLinkToDetail'
import {IoIosShareAlt} from "react-icons/io";
import {LocalContext} from "../../../../modules/local/LocalContext";
import {FiEdit3} from "react-icons/fi";
import TooltipApp from "components/TooltipApp";

export const MainViewItem = ({default_id}) => {
    const t = useTranslate()
    const myDivRef = useRef(null);
    const [refreshToken, setRefreshToken] = useState()
    const [defaultId, setDefaultId] = useState(default_id)
    const [selectedItem, setSelectedItem] = useState()
    const [list, setList] = useState([])
    const {timezone_offset_in_hours} = useContext(LocalContext)

    const history = useHistory()

    const onRefresh = () => {
        setRefreshToken(Date.now())
    }
    const onBack = () => {
        let _list = _.cloneDeep(list);
        _list.pop();
        let newVal = _list[_list.length - 1];
        setList(prevList => {
            return _list;
        });

        setSelectedItem(prevSelectedItem => {
            return newVal;
        });
    };

    const {response, isLoading, handleAsyncAction: fetchRandomGodWords} = useAsyncAction({
        apiInfo: godwords_getSuggestedWords_Api,
        onSuccess: (result, data) => {
            let arr = list;
            arr.push(_.get(data, 'response.data.data.0'));
            if (arr.length > 100) {
                arr.shift();
            }
            setList(arr)
        }
    })
    const {
        modal,
        handleAction,
        handleCaptureImage,
        onVote, onDevote
    } = useGodWords({
        notifyListeners: {
            onVotedSuccess: (result) => {
                onRefresh()
            },
            onDevotedSuccess: (result) => {
                onRefresh()
            },
            onCreated: (result, data) => {
                setDefaultId(result);
            },
            onUpdated: (result, data) => {
                // setDefaultId(result);
            }
        },
    })

    useEffect(() => {
        fetchRandomGodWords(
            {limit: 1, timezone_offset_in_hours, id: defaultId},
            {}
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultId, refreshToken])
    useEffect(() => {
        const data = _.get(response, 'data.data', []);
        const selectedItem = _.get(data, '0', {})
        setSelectedItem(selectedItem);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [response])

    useEffect(() => {
        if (myDivRef && myDivRef.current && selectedItem?.id) {
            if (!!!selectedItem?.photo) {
                setTimeout(() => {
                    handleCaptureImage(myDivRef.current, selectedItem)
                }, 3000);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedItem])

    const tags = _.split(selectedItem?.hashtags || "", ',').filter(e => e)

    return (
        <React.Fragment>
            <SelectEntityItem
                item={selectedItem}
                schema={godwordsSchema}>
                {(sItem) => {
                    const selItem = !!sItem ? sItem : selectedItem;
                    return (
                        <GodWordCardItem
                            item={selItem}
                            onClick={() => {
                                history.push({
                                    pathname: getLinkToDetail(selItem),
                                })
                            }}
                            Wrapper={({children}) => (
                                <div className="flex flex-col gap-4 relative"
                                     style={{minHeight: 390}}>
                                    <div
                                        ref={myDivRef}
                                        className="p-4 flex flex-center shadow-lg rounded-3xl"
                                        style={{
                                            minHeight: 360,
                                            background: `linear-gradient(135deg, #818cf8 0%, #67e8f9 100%)`,
                                            backgroundPosition: 'center',
                                            backgroundSize: 'cover',
                                        }}>
                                        {children}
                                    </div>
                                    {/* TAG */}
                                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                                        {tags.map((e, i) => (
                                            <span
                                                key={i}
                                                style={{padding: '3px 12px'}}
                                                className="w-fit border border-blue-300 font-medium text-xs text-blue-500 italic rounded-full leading-tight">
                                                {`#${e}`}
                                            </span>
                                        ))}
                                    </div>
                                    {/* Action */}
                                    <div className="flex items-center gap-2 mt-3 mb-2">
                                        <RequiredAdmin type={"god_word"}>
                                            <TooltipApp title={t('add words of god')}
                                                        classNames={{root: "font-medium text-xs italic"}}>
                                                <HeaderButton
                                                    onClick={() => {
                                                        handleAction(CRUD.CREATE)
                                                    }}
                                                    width={32}
                                                    height={32}
                                                    icon={<PiPlusBold size={16}/>}
                                                />
                                            </TooltipApp>

                                            <TooltipApp title={t('edit words of god')}
                                                        classNames={{root: "font-medium text-xs italic"}}>
                                                <HeaderButton
                                                    onClick={() => {
                                                        handleAction(CRUD.UPDATE, selItem)
                                                    }}
                                                    width={32}
                                                    height={32}
                                                    icon={<FiEdit3 size={16}/>}
                                                />
                                            </TooltipApp>

                                            <TooltipApp title={t('capture')}
                                                        classNames={{root: "font-medium text-xs italic"}}>
                                                <HeaderButton
                                                    onClick={() => {
                                                        if (myDivRef && myDivRef.current) {
                                                            handleCaptureImage(myDivRef.current, selItem)
                                                        }
                                                    }}
                                                    width={32}
                                                    height={32}
                                                    icon={
                                                        renderIfElse(
                                                            !!selItem?.photo,
                                                            <BsCameraFill size={16}/>,
                                                            <BsCamera size={16}/>
                                                        )
                                                    }
                                                />
                                            </TooltipApp>
                                        </RequiredAdmin>

                                        <TooltipApp title={t('vote')} classNames={{root: "font-medium text-xs italic"}}>
                                            <HeaderButton
                                                onClick={() => {
                                                    if (!!selItem?.vote_status) {
                                                        onDevote({owner_type: 'god_word', owner_id: selItem?.id})
                                                    } else {
                                                        onVote({owner_type: 'god_word', owner_id: selItem?.id})
                                                    }
                                                }}
                                                width={32}
                                                height={32}
                                                icon={renderIfElse(
                                                    !!selItem?.vote_status,
                                                    <IoHeartSharp size={16}/>,
                                                    <IoHeartOutline size={16}/>
                                                )}
                                            />
                                        </TooltipApp>

                                        <Share
                                            actions={
                                                [
                                                    "open_link_in_new_tab",
                                                    "copy_link",
                                                    "share_via",
                                                    "share_via_others"
                                                ]
                                            }
                                            title={getTitle(selItem)}
                                            context={WoGContext}
                                            url={getAbsoluteLinkToDetail(selItem)}
                                            id={selItem?.id}
                                            component={
                                                <TooltipApp title={t('share')}
                                                            classNames={{root: "font-medium text-xs italic"}}>
                                                    <HeaderButton
                                                        width={32}
                                                        height={32}
                                                        icon={<IoIosShareAlt size={18}/>}
                                                    />
                                                </TooltipApp>
                                            }
                                        />

                                        <div className="flex-1"/>

                                        {renderIf(
                                            list.length > 1,
                                            <TooltipApp title={t('prev ask')}
                                                        classNames={{root: "font-medium text-xs italic"}}>
                                                <HeaderButton
                                                    onClick={onBack}
                                                    width={32}
                                                    height={32}
                                                    icon={<IoPlaySkipBackOutline size={16}/>}
                                                />
                                            </TooltipApp>
                                        )}
                                        <TooltipApp title={t('choose words of god')} placement="left"
                                                    classNames={{root: "font-medium text-xs italic"}}>
                                            <RiRefreshFill
                                                onClick={() => {
                                                    fetchRandomGodWords({
                                                        limit: 1,
                                                        timezone_offset_in_hours,
                                                        exclude_id: selItem?.id
                                                    }, {})
                                                }}
                                                size={30}
                                                className="text-green-500 hover:text-green-700 cursor-pointer"
                                            />
                                        </TooltipApp>
                                    </div>
                                </div>
                            )}
                            // item={item}
                        />
                    )
                }}
            </SelectEntityItem>
            {modal}
        </React.Fragment>
    )
}


